<template>
  <div class="contacts-page row">
    <div class="left-wrap medium-12">
      <model-header :header-title="pageTitle" :meta="kanbanMeta" :button-text="$t('SURVEY_MGMT.MODELS.HEADER_BTN_TXT')"
        @open-add-modal="openAddModel" />
      <div class="cards-container">
        <model-card v-for="model in combinedModels" :key="model.id" :heading="model.name" :content="model.description"
          :buttonText="buttonText" :hasSecondaryButton="true" :primaryButtonText="$t('SURVEY_MGMT.MODELS.EDIT')"
          :secondaryButtonText="$t('SURVEY_MGMT.MODELS.NEW_SURVEY')" @primary-action="openEditModel(model)"
          @secondary-action="openSurveyModel(model)" @header-button="openDeleteTable(model)"
          :is-editable="!model.is_fixed" />
      </div>
      <woot-modal :show.sync="showAddModel" :on-close="closeAddModel" size="medium">
        <new-model @on-close="closeAddModel"/>
      </woot-modal>
      <woot-modal :show.sync="showEditModel" :on-close="closeEditModel" size="medium">
        <edit-model @on-close="closeEditModel" :editModel="selectedModel" />
      </woot-modal>
      <woot-modal :show.sync="showSurveyModel" :on-close="closeSurveyModel" size="medium">
        <survey-by-model @on-close="closeSurveyModel" :editModel="selectedModel" />
      </woot-modal>
      <woot-modal :show.sync="showDeleteTablePopup" :on-close="closeDeleteGroup">
        <woot-confirm-delete-modal v-if="showDeleteTablePopup" :show.sync="showDeleteTablePopup" :title="$t('SURVEY_MGMT.MODELS.DELETE.TITLE')"
          :message="$t('SURVEY_MGMT.MODELS.DELETE.MESSAGE')" :confirm-text="$t('SURVEY_MGMT.MODELS.DELETE.CONFIRM_TEXT')" reject-text="Cancelar"
          :confirm-value="$t('SURVEY_MGMT.MODELS.DELETE.CONFIRM_VALUE')" :confirm-place-holder-text="$t('SURVEY_MGMT.MODELS.DELETE.PLACEHOLDER')"
          @on-confirm="confirmTableDeletion" @on-close="closeDeleteGroup" />
      </woot-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DEFAULT_MODELS } from '../constants';
import ModelHeader from './Header';
import alertMixin from 'shared/mixins/alertMixin';
import NewModel from './NewModel.vue';
import EditModel from './EditModel.vue';
import ModelCard from '../../../../components/ui/ModelCard.vue'
import SurveyByModel from './SurveyByModel.vue';

export default {
  components: {
    ModelHeader,
    NewModel,
    EditModel,
    ModelCard,
    SurveyByModel,
  },
  mixins: [alertMixin],

  data() {
    return {
      columns: [],
      kanbanId: 0,
      showAddModel: false,
      showEditModel: false,
      modelToDelete: {},
      showDeleteTablePopup: false,
      showSurveyModel: false,
      loading: false,
      kanbanMeta: {},
      heading: "Teste",
      content: "content",
      src: "src",
      buttonText: "Selecionar Modelo",
      selectedModel: null,
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
      kanbanList: 'getKanbanfunnels',
      currentAccountId: 'getCurrentAccountId',
      getAccount: 'accounts/getAccount',
      getModels: 'customSurveys/getAllModels',
    }),
    pageTitle() {
      return this.$t('SURVEY_MGMT.MODELS.HEADER');
    },
    combinedModels() {
      return [...this.getModels];
    },
  },

  watch: {
  },
  mounted() {
    this.$store.dispatch('customSurveys/getModel');
    this.$store.dispatch('agents/get');
  },
  methods: {
    closeDeleteGroup() {
      this.showDeleteTablePopup = false;
    },
    async deleteTable(id) {
      try {
        await this.$store.dispatch('customSurveys/deleteModel', {
          id: id,
        });
        this.showAlert(this.$t('SURVEY_MGMT.MODELS.DELETE.SUCCESS_MESSAGE'));
      } catch (error) {
        const errorMessage =
          error?.response?.message ||
          this.$t('SURVEY_MGMT.MODELS.DELETE.ERROR_MESSAGE');
        console.log(error)
        this.showAlert(errorMessage);
      }
    },
    confirmTableDeletion() {
      this.deleteTable(this.modelToDelete.id);
      this.modelToDelete = null;
      this.closeDeleteGroup();
    },
    openDeleteTable(model) {
      this.modelToDelete = model;
      this.showDeleteTablePopup = true;
    },
    openAddModel() {
      this.selectedModel = null;
      this.showAddModel = true;
    },
    openEditModel() {
      this.showEditModel = true;
    },
    openSurveyModel(model) {
      this.selectedModel = model;
      this.showSurveyModel = true;
    },
    closeSurveyModel() {
      this.showSurveyModel = false;
    },
    closeAddModel() {
      this.showAddModel = false;
    },
    closeEditModel() {
      this.showEditModel = false;
    },
    openEditModel(model) {
      this.selectedModel = model;
      this.showEditModel = true;
    },
    handleKanbanSelected(selectedKanban) {
      this.kanbanId = selectedKanban;
      this.getTicketsDefault(selectedKanban);
    },
    async getTicketsDefault(kanbanId) {
      const params = {
        kanbanfunnel_id: kanbanId,
        per_page: 10,
      };

      this.loading = true;
      const columsTickets = await this.$store.dispatch(
        'getTicketsByKanban',
        params
      );
      this.columns = columsTickets?.columns;
      this.kanbanMeta = columsTickets?.kanban_meta;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.contacts-page {
  width: 100%;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 30px;
}

.loading {
  text-align: center;
}

.left-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>